import _extends from "@babel/runtime/helpers/extends";
import { Box } from '@wix/design-system';
import React from 'react';
import { EntryItem } from './EntryItem';
export const EntriesList = _ref => {
  let {
    entries,
    onViewDetails,
    ...otherProps
  } = _ref;
  return /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    gap: "SP2"
  }, entries.map((entry, index) => {
    const handleViewDetails = () => onViewDetails(entry);
    return /*#__PURE__*/React.createElement(EntryItem, _extends({
      key: index,
      entry: entry,
      onViewDetails: handleViewDetails
    }, otherProps));
  }));
};
//# sourceMappingURL=EntriesList.js.map